// extracted by mini-css-extract-plugin
export default {"cls1":"_Hr601WqRsbJhJQWSpUX","cls2":"pRDpuOdYSLCHPFYC6FeS _Hr601WqRsbJhJQWSpUX"};